export default __webpack_public_path__ + "73ceb0c526faa16173e859702cc1048c.png";